import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "search-container mb-10"
};
const _hoisted_2 = {
  class: "ml-20"
};
const _hoisted_3 = {
  class: "status-dots"
};
const _hoisted_4 = {
  key: 0,
  class: "infra-operation-btn"
};
const _hoisted_5 = ["href"];
const _hoisted_6 = ["href"];
const _hoisted_7 = {
  class: "batch-operation-btn mt-10"
};
import { onMounted, ref, toRefs } from 'vue';
import { Search, EditPen, CaretRight, MuteNotification, Clock, Download } from '@element-plus/icons-vue';
import { storeToRefs } from 'pinia';
import { globalSearchCountApi, globalSearchApi, lastHourStatusApi } from '@/api/home/globalSearch';
import MctSelectSearch from '@/components/MctSelectSearch.vue';
import { useUserDefaultSettingStore } from '@/store/user';
import { useMaintainStore } from '@/store/maintain';
import { useSnoozeStore } from '@/store/snooze';
import { useSetTimerStore } from '@/store/setTimer';
import { useManualTestStore } from '@/store/manualTest';
import { exportClusterApi } from '@/api/management/importExportCluster';
export default /*@__PURE__*/_defineComponent({
  __name: 'global-search',
  props: {
    searchValue: {}
  },
  emits: ["resetSearchValue"],
  setup(__props, {
    emit: __emit
  }) {
    const userDefaultSettingStore = useUserDefaultSettingStore();
    const {
      privilege
    } = storeToRefs(userDefaultSettingStore);
    const maintainStore = useMaintainStore();
    const {
      showMaintainDialog
    } = maintainStore;
    const snoozeStore = useSnoozeStore();
    const {
      showSnoozeDialog
    } = snoozeStore;
    const useSetTimer = useSetTimerStore();
    const {
      setTimerInfo
    } = useSetTimer;
    const manualTestStore = useManualTestStore();
    const {
      showManualTestTrigger
    } = manualTestStore;
    const props = __props;
    const {
      searchValue
    } = toRefs(props);
    const globalSearchValue = ref(searchValue.value);
    const emits = __emit;
    const tableRowClassName = ({
      rowIndex
    }) => {
      if (rowIndex % 2 === 0) {
        return 'singular-row';
      }
      return '';
    };
    const currentPage = ref(1);
    const pageSize = ref(50);
    const handleCurrentChange = async () => {
      getGlobalSearchResult(globalSearchValue.value);
    };
    const globalSearchCount = ref(0);
    const globalSearchResult = ref([]);
    const checkIdList = ref([]);
    const topBarQuickSearch = async () => {
      const [searchLevel, searchVal] = globalSearchValue.value;
      const {
        memberCount
      } = await globalSearchCountApi(searchVal, searchLevel);
      globalSearchCount.value = memberCount;
      const pageNum = currentPage.value - 1;
      const {
        clusterSearchResultList
      } = await globalSearchApi(searchVal, searchLevel, pageNum);
      checkIdList.value = [];
      globalSearchResult.value = clusterSearchResultList.map(cluster => {
        if (cluster.clusterSearchResults?.length) {
          cluster.clusterSearchResults.map(check => {
            checkIdList.value.push(check.id);
          });
          cluster.children = cluster.clusterSearchResults;
        }
        if (cluster.zoneSearchResults?.length) {
          cluster.children = cluster.zoneSearchResults;
        }
        cluster.level = 0;
        return cluster;
      });
    };
    const iconMap = {
      1: 'mct-bg-green',
      'green.gif': 'mct-bg-green',
      'greenhttp.gif': 'mct-bg-green',
      2: 'mct-bg-blue',
      'greenhttps.gif': 'mct-bg-blue',
      5: 'mct-bg-red',
      'red.gif': 'mct-bg-red',
      'redhttp.gif': 'mct-bg-red',
      'redhttps.gif': 'mct-bg-red',
      6: 'mct-bg-red2',
      'rederror.gif': 'mct-bg-red2',
      4: 'mct-bg-red1',
      'purple.gif': 'mct-bg-red1',
      0: 'mct-bg-grey',
      'white.gif': 'mct-bg-grey',
      3: 'mct-bg-yellow',
      'yellow.gif': 'mct-bg-yellow',
      7: 'mct-bg-violet',
      'selfIssue.gif': 'mct-bg-violet'
    };
    const getLastHourStatus = async () => {
      if (!checkIdList.value?.length) {
        return;
      }
      const {
        serverStatusItems
      } = await lastHourStatusApi(checkIdList.value);
      globalSearchResult.value.map(cluster => {
        cluster.children.map(check => {
          const target = serverStatusItems.find(target => target.id === check.id);
          if (target?.display1?.length) {
            check.status = target.display1;
          }
          return check;
        });
        return cluster;
      });
    };
    const handleExport = async clusterName => {
      await exportClusterApi(clusterName);
    };
    const handleManualTest = (e, data) => {
      showManualTestTrigger(e.target, {
        clusterId: data.id,
        level: 'Cluster'
      });
    };
    const getGlobalSearchResult = async searchParams => {
      globalSearchValue.value = searchParams;
      emits('resetSearchValue', searchParams);
      await topBarQuickSearch();
      if (['1', '2'].includes(searchParams[0])) {
        await getLastHourStatus();
      }
    };
    onMounted(() => getGlobalSearchResult(globalSearchValue.value));
    return (_ctx, _cache) => {
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_tooltip = _resolveComponent("el-tooltip");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_pagination = _resolveComponent("el-pagination");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createVNode(MctSelectSearch, {
        "search-value": globalSearchValue.value,
        "search-placeholder": "Hostname/IP/Subnet",
        onTriggerSelectSearch: getGlobalSearchResult
      }, null, 8, ["search-value"]), _createElementVNode("div", _hoisted_2, _toDisplayString(globalSearchCount.value) + " results were found, 50 records per page. ", 1)]), _createVNode(_component_el_table, {
        data: globalSearchResult.value,
        style: {
          "width": "99%"
        },
        fit: "",
        "row-key": "id",
        "default-expand-all": "",
        "row-class-name": tableRowClassName,
        border: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          prop: "name",
          label: "Name"
        }), _createVNode(_component_el_table_column, {
          prop: "typeName",
          label: "Type",
          width: "200"
        }), _createVNode(_component_el_table_column, {
          prop: "status",
          label: "Current Hour Status"
        }, {
          default: _withCtx(scope => [_createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row?.status, (dot, index) => {
            return _openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["dot-wrap", [1, 2].includes(dot?.resultType) ? 'maintained' : '']),
              key: index
            }, [_createElementVNode("div", {
              class: _normalizeClass(["dot", iconMap[dot.icon]])
            }, null, 2)], 2);
          }), 128))])]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          label: "Action",
          width: "260"
        }, {
          default: _withCtx(scope => [scope.row.level === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(_component_el_tooltip, {
            class: "box-item",
            effect: "light",
            content: "Edit",
            placement: "top"
          }, {
            default: _withCtx(() => [_createElementVNode("a", {
              class: "mr-5",
              href: '/infrastructure/' + scope.row.id,
              target: "_blank",
              rel: "opener"
            }, [_createVNode(_component_el_button, {
              type: "success",
              icon: _unref(EditPen),
              size: "small",
              circle: ""
            }, null, 8, ["icon"])], 8, _hoisted_5)]),
            _: 2
          }, 1024), _unref(privilege) === 255 ? (_openBlock(), _createBlock(_component_el_tooltip, {
            key: 0,
            class: "box-item",
            effect: "light",
            content: "Manual Test",
            placement: "top"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              id: "manual-test",
              type: "success",
              icon: _unref(CaretRight),
              size: "small",
              onClick: $event => handleManualTest($event, scope.row),
              circle: ""
            }, null, 8, ["icon", "onClick"])]),
            _: 2
          }, 1024)) : _createCommentVNode("", true), _unref(privilege) === 255 ? (_openBlock(), _createBlock(_component_el_tooltip, {
            key: 1,
            class: "box-item",
            effect: "light",
            content: "Maintain/Recover",
            placement: "top"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              onClick: $event => _unref(showMaintainDialog)(scope.row.id, 'Cluster'),
              type: "primary",
              size: "small",
              circle: ""
            }, {
              icon: _withCtx(() => _cache[2] || (_cache[2] = [_createElementVNode("svg", {
                class: "rotate-x-180",
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
              }, [_createElementVNode("path", {
                d: "M968.299 577.387c57.92 59.392 70.379 146.987 38.741 219.328l-129.664-132.907c-24.896-25.515-65.621-25.515-90.517 0s-24.896 67.264 0 92.8l131.733 135.019c-72 37.184-161.771 25.792-221.888-35.84-63.253-64.832-72.939-163.541-29.483-239.019l-96.32-100.821-184.875 189.483 167.552 171.755c-80 82.005-210.923 82.005-290.944 0l-68.693-70.4-28.032 28.715c-11.243 11.541-29.653 11.541-40.896 0l-116.587-119.296c-11.243-11.52-11.243-30.379 0-41.899l153.067-156.885c11.243-11.52 29.653-11.52 40.896 0l115.733 118.443 185.579-190.229-263.957-276.331c-18.667-19.136-18.667-50.453 0-69.611 18.667-19.115 49.237-19.115 67.904 0l263.979 276.331 268.8-275.499c18.667-19.136 49.216-19.136 67.883 0 18.709 19.115 18.709 50.453 0 69.589l-269.525 276.245 96.299 100.779c73.643-44.501 169.963-34.581 233.216 30.251z"
              })], -1)])),
              _: 2
            }, 1032, ["onClick"])]),
            _: 2
          }, 1024)) : _createCommentVNode("", true), _unref(privilege) === 255 ? (_openBlock(), _createBlock(_component_el_tooltip, {
            key: 2,
            class: "box-item",
            effect: "light",
            content: "Snooze/Recover",
            placement: "top"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              onClick: $event => _unref(showSnoozeDialog)(scope.row.id),
              type: "warning",
              icon: _unref(MuteNotification),
              size: "small",
              circle: ""
            }, null, 8, ["onClick", "icon"])]),
            _: 2
          }, 1024)) : _createCommentVNode("", true), _unref(privilege) === 255 ? (_openBlock(), _createBlock(_component_el_tooltip, {
            key: 3,
            class: "box-item",
            effect: "light",
            content: "Timer Setting",
            placement: "top"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              type: "warning",
              icon: _unref(Clock),
              size: "small",
              circle: "",
              onClick: $event => _unref(setTimerInfo)(scope.row.id, 'Cluster', 0)
            }, null, 8, ["icon", "onClick"])]),
            _: 2
          }, 1024)) : _createCommentVNode("", true), _createVNode(_component_el_tooltip, {
            class: "box-item",
            effect: "light",
            content: "Export Cluster",
            placement: "top"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              type: "warning",
              icon: _unref(Download),
              size: "small",
              onClick: $event => handleExport(scope.row.name),
              circle: ""
            }, null, 8, ["icon", "onClick"])]),
            _: 2
          }, 1024), _createVNode(_component_el_tooltip, {
            class: "box-item",
            effect: "light",
            content: "Cluster Status",
            placement: "top"
          }, {
            default: _withCtx(() => [_createElementVNode("a", {
              class: "ml-5",
              href: '/cluster-status/' + scope.row.id,
              target: "_blank",
              rel: "opener"
            }, [_createVNode(_component_el_button, {
              type: "warning",
              icon: _unref(Search),
              size: "small",
              circle: ""
            }, null, 8, ["icon"])], 8, _hoisted_6)]),
            _: 2
          }, 1024)])) : _createCommentVNode("", true)]),
          _: 1
        })]),
        _: 1
      }, 8, ["data"]), _createElementVNode("div", _hoisted_7, [_createVNode(_component_el_pagination, {
        "current-page": currentPage.value,
        "onUpdate:currentPage": _cache[0] || (_cache[0] = $event => currentPage.value = $event),
        "page-size": pageSize.value,
        "onUpdate:pageSize": _cache[1] || (_cache[1] = $event => pageSize.value = $event),
        layout: "total, sizes, prev, pager, next, jumper",
        total: globalSearchCount.value,
        "page-sizes": [50],
        onCurrentChange: handleCurrentChange
      }, null, 8, ["current-page", "page-size", "total"])])], 64);
    };
  }
});